export default "__VITE_ASSET__5svKH2IF__"